import React, { useContext, useRef, useState } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField/TextField';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import { useSubmitDeviceList } from '../../api/hooks/inventory';
import { MenuItem } from '@mui/material';
import { ToastContext } from '../../contexts/toast';
import { useQueryClient } from 'react-query';
import { GUARANTEES_PART_INFO_KEY } from '../../api/hooks/cache-keys';
import { ModalContext } from '../../contexts/modal';
import { useGetFirms } from '../../api/hooks/sales';

export default function NewPartForm() {
  const { data: guarantees } = useGetFirms(true);
  const submitDevices = useSubmitDeviceList();
  const queryClient = useQueryClient();
  const { showToast } = useContext(ToastContext);
  const { setOpen: setOpenModal } = useContext(ModalContext);
  const [selectedFile, setSelectedFile] = useState(null);
  const [owner, setOwner] = useState(null);

  const formRef = useRef();
  function handleDelete() {
    setSelectedFile(null);
    formRef.current.reset();
  }

  function onFileChange(event) {
    setSelectedFile(event.target.files[0]);
  }
  async function sumbitRequest() {
    try {
      await submitDevices.mutateAsync({ ownerId: owner, records: selectedFile });
      queryClient.invalidateQueries(GUARANTEES_PART_INFO_KEY());
      showToast('پارت جدید ساخته شد.', 'success');
      setOpenModal(false);
    } catch (e) {
      console.log(e);
      showToast('مشکلی پیش آمده است.', 'error');
    }
  }

  return (
    <Container maxWidth="xs">
      <form ref={formRef}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="مالک"
              size="small"
              onChange={(e) => setOwner(e.target.value)}
            >
              {guarantees?.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            {selectedFile && <Chip label={selectedFile.name} onDelete={handleDelete} />}
          </Grid>
          <Grid item xs={12}>
            <input
              onChange={onFileChange}
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              style={{ display: 'none' }}
              id="raised-button-file"
              multiple
              type="file"
            />
            {selectedFile ? (
              <Button fullWidth variant="contained" disabled={!owner} onClick={sumbitRequest}>
                ارسال
              </Button>
            ) : (
              <label htmlFor="raised-button-file">
                <Button fullWidth variant="contained" component="span">
                  انتخاب فایل IMEI ها
                </Button>
              </label>
            )}
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
